import axios from 'axios';
import apiUrl from '../../../constants';

export function fetchImage(filePath,token){
    let input = ({
        key: filePath,
        fileName: 'download.png',
      });

      console.log("input ::",input);
    
      return axios({
        method: 'post',
        url: `${apiUrl.api_url}fetchImages3`,
        data: input,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
}




// WEBPACK FOOTER //
// ./src/services/B2b/services/fetchImages.js